import { useState } from "react";
import { Link } from "react-router-dom";
import { sanitizeImage } from "../sanitize-image";
import { readChosenPhoto } from "../chosen-photo";

export default function PrepareNewPostcardsPage() {
  const [message, setMessage] = useState("Ready to place the 11 photos in your private review queue.");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  async function load(files: FileList | null) {
    if (!files || files.length !== 11) { setMessage("Choose all 11 postcard photos together."); return; }
    setBusy(true);
    setDone(false);
    try {
      // All eleven are copied off the phone up front: the last one otherwise waits behind
      // ten uploads, long enough for Android to stop letting the browser read it.
      // A failure names the postcard, in the words this page already uses for one: the read's
      // own "Choose it again" would contradict the "Choose the same 11" appended below.
      const photos = await Promise.all(Array.from(files).map((file, index) =>
        readChosenPhoto(file).catch(() => { throw new Error(`Postcard ${index + 1} could not be uploaded.`); })));
      for (let index = 0; index < photos.length; index += 1) {
        setMessage(`Uploading postcard ${index + 1} of ${photos.length}…`);
        const form = new FormData();
        const cleanPhoto = await sanitizeImage(photos[index], photos[index].name);
        form.append("photo", cleanPhoto, cleanPhoto.name);
        const response = await fetch("/api/postcards/drafts/seed", { method: "POST", body: form });
        const result = await response.json().catch(() => ({ error: "The upload stopped unexpectedly." })) as { error?: string };
        if (!response.ok) throw new Error(result.error ?? `Postcard ${index + 1} could not be uploaded.`);
      }
      setMessage("All 11 photos are safely in your private review queue.");
      setDone(true);
    } catch (error) {
      setMessage(`${error instanceof Error ? error.message : "The upload stopped."} Choose the same 11 photos to continue safely.`);
    } finally {
      setBusy(false);
    }
  }
  return <main className="app-shell"><section className="empty-state"><div className="empty-stamp">✉</div><h1>Prepare new postcards</h1><p aria-live="polite">{message}</p>{done ? <Link className="primary-button" to="/">Review postcards one by one</Link> :<label className="primary-button">{busy ? "Uploading…" : "Choose 11 photos"}<input aria-label="Choose 11 postcard photos" type="file" accept="image/*" multiple hidden disabled={busy} onChange={(event) => load(event.target.files)} /></label>}</section></main>;
}
